import React, { Component } from "react";


export default class TYDropDownSeparator extends Component{
    render(){
        return (
            <div className="dropdown-separator" />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/TYDropDown/separator.js